<template lang="pug">
div.ag-custom-cell.ag-cell-percent(:class='{ "invalid": invalidPercent} ')
  div.ag-custom-cell-value {{ percentValue }}
  | &nbsp;&nbsp;
</template>

<script>

export default {
  data() {
    return {
      //
      invalidPercent: false
    }
  },

  computed: {
    //
    percentValue() {
      return this.params.node.rowPinned === 'bottom'
        ? ''
        : `${(+this.params.value || 0)} %`
    }
  }
}

</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

.ag-custom-cell {
  display: inline-block;
  min-width: 75%;
  &.ag-cell-percent {
    display: block;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Grid/cells/percent.vue